/* eslint no-underscore-dangle: 0 */
import find from 'lodash/find'

export const createSubcontractList = (list) => {
  let subcontractList = list.filter((sub) => {
    return sub.employee_type === 'Subcontract'
  })
  subcontractList = subcontractList.map((sub) => {
    return {
      label: `${sub.emp_code} - ${sub.first_name} ${sub.last_name} (${sub.nick_name})`,
      value: sub._id,
      emp_code: sub.emp_code,
      name: `${sub.first_name} ${sub.last_name} (${sub.nick_name})`,
    }
  })
  return subcontractList
}
export const createSubcontractCostList = (list, subcontracts) => {
  const subcontractCostList = []
  list.map(cost => {
    const user = find(subcontracts, {
      value: cost.user_id,
    })
    let newCost = {}
    newCost = cost
    newCost.emp_code = user ? user.emp_code : '-'
    newCost.name = user ? user.name : '-'
    newCost.cost_number = parseFloat(cost.cost)
    newCost.price_number = parseFloat(cost.price)
    subcontractCostList.push(newCost)
    return cost
  })
  return subcontractCostList
}




// WEBPACK FOOTER //
// ./src/components/subcontract-cost/helpers/subcontract-cost.js